import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import DOMPurify from "dompurify";

@Pipe({
  name: "safeHtml",
  standalone: false,
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(html: string): SafeHtml {
    const sanitized = DOMPurify.sanitize(html ?? "", {
      ALLOWED_TAGS: [
        "a",
        "b",
        "br",
        "em",
        "i",
        "img",
        "p",
        "span",
        "strong",
        "table",
        "td",
        "tr",
        "div",
        "ul",
        "ol",
        "li",
      ],
    });
    return this.sanitizer.bypassSecurityTrustHtml(sanitized);
  }
}
